module.exports = __webpack_public_path__ + "ic-drag.svg?ccac08dfb9107907a8eda49f8398001f";